import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ToastrService } from 'ngx-toastr';

import { PermissionsEnum } from '../../../../api/api-reference';
import {
  Client,
  PageInfo,
  UserDataOut,
  UserGetAllDataIn,
  UserStatus,
  UserStatusUpdate,
} from '../../../../api/api-reference';
import { AuthService } from '../../../../services/auth.service';
import { SearchComponent } from '../../../core/components/search/search.component';
import { PaginationComponent } from '../../../core/components/pagination/pagination.component';
import {
  alertColors,
  getAlertColor,
} from '../../../events-alarms/alert-colors';
import { MemberInformationComponent } from '../member-information/member-information.component';
import { ConfirmDialogComponent } from '../../../core/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-team-members',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    AngularSvgIconModule,
    SearchComponent,
    PaginationComponent,
    MemberInformationComponent,
    ConfirmDialogComponent,
  ],
  templateUrl: './team-members.component.html',
  styleUrl: './team-members.component.scss',
})
export class TeamMembersComponent implements OnInit {
  public pageSize: number = 5;
  public pageNumber: number = 1;
  public currentPage: number = 1;
  public numberOfMembers: number = 0;
  public lastPageSize: number = 1;
  isModalOpen = false;
  public selectedMember: UserDataOut | undefined;
  selectedRowId: string | null = null;
  activeRow: number | null = null;
  userData: UserDataOut[] | undefined = [];
  requestData = new UserGetAllDataIn({
    pageInfo: new PageInfo({ pageSize: this.pageSize, page: this.pageNumber }),
    search: undefined,
  });

  userStatus: UserStatusUpdate = new UserStatusUpdate();

  //changing colors on refresh
  getColor = getAlertColor;
  colors = alertColors;
  public colorMap: { [key: string]: string } = {};
  public PermissionsEnum = PermissionsEnum;
  UserStatus = UserStatus;

  constructor(
    private toastr: ToastrService,
    public router: Router,
    public client: Client,
    public authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.setInitialColors();
    this.reloadTable(1);
  }

  setInitialColors(): void {
    this.userData!.forEach((row) => {
      this.colorMap[row.firstName!] = this.getColor(row.firstName!.charAt(0));
    });
  }

  searchChange(searchText: string) {
    this.requestData.search = searchText;
    this.reloadTable(1);
  }

  reloadTable(page?: number) {
    this.pageNumber = page || 0;
    if (page) this.requestData!.pageInfo!.page = this.pageNumber;

    this.isModalOpen = false;
    this.selectedMember = undefined;

    this.client.userQuery(this.requestData).subscribe({
      next: (response) => {
        this.userData = response.data;
        this.numberOfMembers = response.count || 0;
        this.lastPageSize = Math.ceil(this.numberOfMembers / this.pageSize);
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
  }

  pageChange(value: number) {
    this.currentPage = value;
    this.reloadTable(this.currentPage);
  }

  handleRowClickUser(row: UserDataOut) {
    if (!this.isModalOpen) this.selectedMember = row;
    else this.selectedRowId = row.hesId!;
  }

  setActiveRow(rowIndex: number | null) {
    this.activeRow = this.activeRow === rowIndex ? null : rowIndex;
  }

  editMember(id: string) {
    this.router.navigate(['settings/team/team-setup'], {
      state: { userData: id },
    });
  }

  changeStatus(id: string, status: UserStatus) {
    this.userStatus.userId = id;
    this.userStatus.status = status;

    this.client.changeUserStatus(this.userStatus).subscribe({
      next: () => {
        this.toastr.success('User successfuly changed status.');
        this.reloadTable();
        this.setActiveRow(null);
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
  }

  delete(id: string) {
    this.client.deleteUser(id).subscribe({
      next: () => {
        this.toastr.success('User successfuly deleted.');
        this.reloadTable();
        this.setActiveRow(null);
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
  }
}
